import { getPageContext, setPageContext, updateCredential, updatePageContextContent } from './state';

/**
 * Listens for messages from the parent window and updates the page context.
 * Message types:
 *   - 'page-url':     Updates the current page URL (and resets content).
 *   - 'page-content': Merges page content if the URL matches.
 */
export function initPageContext(): void {
    window.addEventListener('message', (event) => {
        const data = event.data;
        const dataType = data && data.type;
        const pageData = data && data.data;

        if (dataType === 'page-content') {
            const keys: string[] = pageData.keys;
            const ctx = getPageContext();
            if (keys.find(key => !ctx.url.includes(key))) {
                // URL does not match – ignore this content
            } else {
                updatePageContextContent(pageData.content);
            }
        } else if (dataType === 'page-url') {
            const ctx = getPageContext();
            if (ctx.url !== pageData.url) {
                setPageContext({ url: pageData.url, content: {} });
            }
        } else if (dataType === 'client-user') {
            updateCredential(pageData);
        }
    });
}
